import React, { useEffect, useState, Fragment } from "react";
import { Box, Card, CardContent, Typography } from "@mui/material";

import { textForm, textFormDanhGia } from "../utils";

import theme from "../../../theme";
import KPTextform from "../../../components/KPTComponents/KPTextform";
import AnhChanDung from "../../../components/CommonComponents/AnhChanDung";
import { EDUCATE_DEGREE_CONSTANTS, FORM_MODEL_DANH_GIA } from "../../../constants";

function MucDanhGiaB3({ error, valueThamDinh, setValuesThamDinh, values,formThamDinh }) {
  return (
    <Fragment>
      <Card style={{ width: '100%', marginTop: 16, backgroundColor: 'antiquewhite' }}>
        <CardContent>
        <Typography variant="h6" component="div" marginBottom={2}>
            {'Đánh giá của thẩm định'}
        </Typography>
          <Box display='flex'>
            <Box width='100%'>
              <KPTextform
                component={Box}
                error={error}
                values={valueThamDinh}
                setValues={setValuesThamDinh}
                textForm={formThamDinh?.mucB3 || []}
              />
            </Box>
          </Box>
        </CardContent>
      </Card>
    </Fragment>
  )
  
}

export default MucDanhGiaB3;